import { Link } from '@tanstack/react-router';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from '$/components/common/Icon';
import { ActionCard } from '$/components/core/Projects/components/Cards/ActionCard';

interface Props {
  folderId?: string;
}

export const NewProjectCard: FC<Props> = ({ folderId }) => {
  const { t } = useTranslation();

  return (
    <Link to='/editor' search={() => ({ folderId })}>
      <ActionCard
        icon={<Icon icon='add_sign' h='26px' w='26px' />}
        headerText={t('dashboard.welcome.newProjectButton')}
        background='bodyBackground'
        color='text'
      />
    </Link>
  );
};
